module.exports = __webpack_public_path__ + "img/no-rank.05f196ce.png";